<template>
  <div class="add-tweet">
    <div class="input-label">Your Tweet URL</div>
    <div class="input-box">
      <v-text-field
        v-model.trim="tweetUrl"
        placeholder="Example: https://twitter.com/PubbyReviews/status/1142935792236531714"
        class="title-field"
        @keyup="loadTweet"
      ></v-text-field>
      <div class="field-instructions">
        Please paste in the URL of your tweet. We will display it here for you to verify.
        <br />
        <br />To find your tweet's URL, visit your Twitter profile page and click on your tweet. Then you can copy the URL in your browser's address bar.
      </div>
      <div class="field-error" v-if="tweetUrlError">{{ tweetUrlError }}</div>
      <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>
    <div class="embed-col">
      <div class="embed-heading" v-if="isTweetLoaded">Your Tweet</div>
      <div class="embed" v-html="tweetHtml"></div>
    </div>
    <div class="options-col" v-if="isTweetLoaded">
      <!-- <div class="embed-heading" v-if="isTweetLoaded">Budget</div> -->

      <div class="embed-question">
        How would you like to
        <br />promote your tweet?
      </div>

      <div
        class="promote-option promote-option-paid"
        :class="{'grow': !isPayNowOpen}"
        @click="clickPayNow"
      >
        <div class="promote-option-title">Paid Promotion</div>
        <div class="promote-option-more">One-time payment of $14.99</div>
        <div class="promote-option-description">
          Receive 20 likes and reach 10,000 people
          through retweets on Twitter.
        </div>
        <div class="promote-option-pay" v-if="isPayNowOpen && paymentMethod">
          <div class="payment-line">
            Your
            {{ paymentMethod.card_brand }} card ending in
            <span
              style="font-weight: 600;"
            >{{ paymentMethod.card_last_four }}</span> will be charged
            <span style="font-weight:600;">$14.99</span>.
            <p
              style="padding-top: 12px; padding-bottom: 0; margin-bottom: 0;"
            >Members will see your tweet right away and be able to Like and Retweet it.</p>
          </div>
          <div @click="confirmPayNow" class="payment-button payment-button-later">Confirm Payment</div>
          <!-- <div @click="cancelPayNow" class="payment-button payment-button-cancel">Cancel</div> -->
          <div class="clearfix"></div>
        </div>
      </div>

      <div
        class="promote-option promote-option-snaps"
        :class="{'grow': !isUseSnapsOpen}"
        @click="clickUseSnaps"
      >
        <div class="promote-option-title">Use Your Snaps</div>
        <!-- <div class="promote-option-more">Each Like and Retweet costs a little bit of snaps.</div> -->
        <div
          class="promote-option-description"
          v-if="!isUseSnapsOpen"
        >Each Like and Retweet costs a little bit of snaps. You can set a budget of how many snaps to spend.</div>

        <div v-if="isUseSnapsOpen">
          <div
            class="field-instructions field-instructions-budget field-instructions-first field-instructions-important"
          >
            Set the amount of snaps you would like to spend to get Likes and Retweets for your tweet.
            <br />
            <br />
            <b
              style="font-weight:600;"
            >Your snaps will not be removed now. They will only be removed after users Like or Retweet it.</b>
            <br />
          </div>

          <div class="input-label input-label-small input-budget-em">Likes</div>
          <div class="input-box input-box-small">
            <v-text-field
              v-model.trim="likesBudget"
              placeholder="# of snaps to spend"
              class="title-field"
            ></v-text-field>
            <div class="field-error" v-if="likesBudgetError">{{ likesBudgetError }}</div>
          </div>
          <img src="/images/icons/snap.svg" class="earn-snaps-img" />
          <div class="earn-snaps-label">snaps</div>

          <div class="clearfix"></div>
          <div class="field-instructions field-instructions-budget">Each Like costs 20 snaps.</div>
          <div class="clearfix"></div>

          <div class="input-label input-label-small input-budget-em">Retweets</div>
          <div class="input-box input-box-small">
            <v-text-field
              v-model.trim="retweetsBudget"
              placeholder="# of snaps to spend"
              class="title-field"
            ></v-text-field>
            <div class="field-error" v-if="retweetsBudgetError">{{ retweetsBudgetError }}</div>
          </div>
          <img src="/images/icons/snap.svg" class="earn-snaps-img" />
          <div class="earn-snaps-label">snaps</div>

          <div class="clearfix"></div>
          <div class="field-instructions field-instructions-budget">
            The cost of each Retweet is the # of followers of the user who retweets it, divided by 8.
            <br />
            <br />Example: If a person with 1,000 followers retweets your tweet, it would cost 125 snaps.
            <br />
            <br />If the user has less than 250 followers, the cost of the Retweet is 50.
          </div>
          <div class="clearfix"></div>

          <div class="action add-tweet-button" @click="submitForm">Add Tweet</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "../../modules/Back";
import { mapState } from "vuex";

export default {
  name: "Tweet",
  data: function() {
    return {
      tweetUrl: "",
      tweetUrlError: null,
      isTweetLoaded: false,
      likesBudget: null,
      retweetsBudget: null,
      likesBudgetError: null,
      retweetsBudgetError: null,
      tweetHtml: "<div></div>",
      paymentMethod: null,
      isPayNowOpen: false,
      isUseSnapsOpen: false
    };
  },
  computed: {
    ...mapState({
      user: "user"
    })
  },
  methods: {
    async clickPayNow() {
      this.isPayNowOpen = true;
      this.isUseSnapsOpen = false;

      if (!this.paymentMethod) {
        this.getUserPaymentMethod();
      }
    },
    async clickUseSnaps() {
      this.isPayNowOpen = false;
      this.isUseSnapsOpen = true;

      if (!this.paymentMethod) {
        this.getUserPaymentMethod();
      }
    },
    async confirmPayNow() {
      const response = await Back.addPaidTweet(this.tweetUrl);

      console.log("paid response", response);

      if (!response) {
        return this.$toasted.show(
          "Oops! Something went wrong. Please try again later or contact our support team.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000
          }
        );
      }

      if (response.message === "Tweet already promoted") {
        this.$toasted.show(
          "Oops! This tweet has already been promoted on Pubby.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      } else if (response) {
        this.$toasted.show("Great! You added this tweet to be promoted!", {
          icon: "check_circle",
          position: "bottom-center",
          duration: 3000
        });
        this.isTweetLoaded = false;
        this.tweetUrl = null;
        this.tweetHtml = "";
        this.likesBudget = null;
        this.retweetsBudget = null;
        this.isPayNowOpen = false;
        this.$emit("tweetAdded");
      }
    },
    cancelPayNow() {
      this.isPayNowOpen = false;
    },
    async getUserPaymentMethod() {
      const response = await Back.userPaymentMethod();

      if (!response) {
        this.$toasted.show(
          "Your payment method could not be found. Please contact our support team or try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000
          }
        );
      }

      this.paymentMethod = response;

      console.log("getUserPaymentMethod", response);
    },
    async submitForm() {
      // TODO: Full validation.
      if (!this.isTweetLoaded || !this.tweetUrl) {
        return;
      }

      const response = await Back.addTweet(
        this.tweetUrl,
        this.likesBudget,
        this.retweetsBudget
      );

      console.log("response", response);

      if (response.message === "Tweet already promoted") {
        this.$toasted.show(
          "Oops! This tweet has already been promoted on Pubby.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      } else if (response) {
        this.$toasted.show("Great! You added this tweet to be promoted!", {
          icon: "check_circle",
          position: "bottom-center",
          duration: 3000
        });
        this.isTweetLoaded = false;
        this.tweetUrl = null;
        this.tweetHtml = "";
        this.likesBudget = null;
        this.retweetsBudget = null;
        this.$emit("tweetAdded");
      } else {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      }

      console.log("respn", response);
    },
    loadTweet() {
      this.tweetHtml = "";
      this.isTweetLoaded = false;

      if (this.tweetUrl === "t") {
        this.tweetUrl =
          "https://twitter.com/PubbyReviews/status/1142935792236531714";
      }
      if (!this.tweetUrl) {
        this.isTweetLoaded = false;
        return;
      }

      var that = this;
      jsonp("https://publish.twitter.com/oembed?url=" + this.tweetUrl, function(
        data
      ) {
        console.log("data", data);
        that.tweetHtml = data.html;
        setTimeout(function() {
          twttr.widgets.load();
          that.isTweetLoaded = true;
        }, 500);
      });
    }
  },
  mounted() {
    //twttr.widgets.load();
  }
};

function jsonp(url, callback) {
  var callbackName = "jsonp_callback_" + Math.round(100000 * Math.random());
  window[callbackName] = function(data) {
    delete window[callbackName];
    document.body.removeChild(script);
    callback(data);
  };

  var script = document.createElement("script");
  script.src =
    url + (url.indexOf("?") >= 0 ? "&" : "?") + "callback=" + callbackName;
  document.body.appendChild(script);
}
</script>

<style lang="scss" scoped>
.form-content {
  padding: 20px;
}

.input-label {
  float: left;
  width: 170px;
}
.input-box {
  float: left;
  width: 550px;
  font-family: $font-family;
}

.input-label {
  padding: 16px 12px 20px 0;
  font-size: 14pt;
  line-height: 1.4em;
  font-family: $font-family;
}
.input-label-small {
  width: 140px;
  padding-left: 20px;
}
.input-box-small {
  width: 136px;
}

.field-instructions {
  padding-bottom: 16px;
  font-size: 12.5pt;
  line-height: 1.4em;
  color: #666;
  font-family: $font-family;
}
.field-instructions-budget {
  padding-left: 0px;
  padding-top: 0px;
}
.field-instructions-first {
  padding-top: 8px !important;
}
.field-instructions-important {
  color: #111;
}
.field-error {
  padding-bottom: 16px;
  font-size: 12.5pt;
  line-height: 1.4em;
  color: rgb(235, 96, 96);
}

.embed-col {
  float: left;
  width: 540px;
}
.options-col {
  float: left;
  width: 400px;
  padding-top: 72px;
  padding-bottom: 40px;
}

.embed-heading {
  color: $color-blue;
  min-width: 164px;
  padding: 1.5em 0 0.5em 0;
  border-radius: 4px;
  font-size: 13.5pt;
  font-weight: 700;
  text-transform: none;
  font-family: "Source Sans Pro";
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 1px;
}

.embed-question {
  display: none;
  padding: 14px 20px;
  padding-top: 28px;
  font-family: "Source Sans Pro";
  font-size: 17pt;
  font-weight: 600;
  color: #555;
  text-align: center;
  line-height: 1.4em;
}

.input-label {
}

.v-text-field,
.title-field {
  padding-top: 8px !important;
}

.input-budget-em {
  color: $color-blue;
  font-weight: 600;
  padding-left: 0;
  width: 104px;
}

.add-tweet-button {
  margin-top: 8px;
  margin-left: 0px;
  margin-bottom: 10px;
  background: #daedff;
  color: #2196f3;
}

.earn-snaps-label {
  float: left;
  width: 48px;
  margin: 15px 0 0 6px;
  font-family: $font-family;
  font-size: 12pt;
  font-weight: 600;
  color: #ff7043;
}
.earn-snaps-img {
  float: left;
  width: 18px;
  margin: 24px 0 0 6px;
}

.promote-option {
  margin-bottom: 20px;
  padding: 16px 40px 16px 28px;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  border-radius: 8px;
  border-top: 4px solid $color-blue;
  font-family: $font-family;
}
.promote-option-title {
  font-size: 19pt;
  font-weight: 500;
  color: $color-blue;
}
.promote-option-more {
  font-size: 13.5pt;
  font-weight: 600;
  color: darken($color-blue, 0%);
}
.promote-option-description {
  padding-top: 0.5em;
  font-size: 12.5pt;
  font-weight: 500;
  line-height: 1.4em;
}

.promote-option-snaps {
  border-top: 4px solid $color-snaps;
  .promote-option-title {
    color: $color-snaps;
  }
}

.grow {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.payment-line {
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
  margin: 12px 0 16px 0;
  padding: 12px 0 16px 0;
  font-size: 12pt;
  font-weight: 500;
  color: #111;
  font-size: 12pt;
}

.payment-buttons {
  margin: 20px 4px;
}
.payment-button {
  float: left;
  margin-right: 8px;
  margin-bottom: 4px;
  font-size: 13pt;
  font-weight: 600;
  background: darken($color-blue, 4%);
  background: linear-gradient(
    0deg,
    $color-blue 0%,
    lighten($color-blue, 13%) 100%
  );
  border-radius: 4px;
  border: 2px solid darken($color-blue, 4%);
  border-bottom: 2px solid darken($color-blue, 7%);
  color: #fff;
  padding: 6px 18px;
  padding-top: 5px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  text-shadow: 2px 2px 1px rgba(17, 17, 17, 0.25);
  cursor: pointer;
}
.payment-button:hover {
  background: linear-gradient(
    0deg,
    darken($color-blue, 8%) 0%,
    lighten($color-blue, 5%) 100%
  );
}

.payment-button-cancel {
  background: #fff;
  border: 2px solid #fff;
  box-shadow: none !important;
  text-shadow: none !important;
  color: #999;
  border-radius: 6px;
  cursor: pointer;
  //text-decoration: underline;
}
.payment-button-cancel:hover {
  background: #f3f3f3;
  color: #888;
}
.payment-notice {
  padding: 7px 12px 0 14px;
  font-size: 12pt;
  font-weight: 500;
  color: #666;
}
</style>


